import { useFeatureIsOn } from "@growthbook/growthbook-react";

const ASK_FELLOW_SHOW_THINKING_INFO_ICON = "ask-fellow-show-thinking-info-icon";

export function useAskFellowShowThinkingInfoIcon(): boolean {
	return useFeatureIsOn(ASK_FELLOW_SHOW_THINKING_INFO_ICON);
}
